import Leagues from "@/views/Leagues"
import LeagueBase from "@/views/League/Base"
import LeagueHome from "@/views/League/Home"
import LeagueTeams from "@/views/League/Teams"
import LeagueTeamBase from "@/views/League/Team/Base"
import LeagueTeamHome from "@/views/League/Team/Home"
import LeagueTeamSchedule from "@/views/League/Team/Schedule"
import LeagueTeamAlternateSchedules from "@/views/League/Team/AlternateSchedules"
import LeaguePlayoffs from "@/views/League/Playoffs"
import LeagueDraftBase from "@/views/League/Draft/Base"
import LeagueDraftDashboard from "@/views/League/Draft/Dashboard"
import LeagueDraftRounds from "@/views/League/Draft/Rounds"
import LeagueDraftTeams from "@/views/League/Draft/Teams"
import LeaguePlayers from "@/views/League/Players"
import LeagueFAQs from "@/views/League/FAQs"

const title = (text) => text + " - ffstats.io"

export default [
	{
		path: "/",
		component: Leagues,
		meta: {
			title: title("Leagues"),
			tags: [
				{
					name: "description",
					content: "ffstats.io home page",
				},
			],
		},
	},
	{
		path: "/leagues/:leagueKey",
		component: LeagueBase,
		children: [
			{
				path: "",
				name: "league-home",
				component: LeagueHome,
				meta: {
					title: title("Dashboard"),
				},
			},
			{
				path: "teams",
				name: "league-teams",
				component: LeagueTeams,
				meta: {
					title: title("Teams"),
				},
			},
			{
				path: "teams/:teamKey",
				component: LeagueTeamBase,
				children: [
					{
						path: "",
						name: "league-team-home",
						component: LeagueTeamHome,
						meta: {
							title: title("Team Home"),
						},
					},
					{
						path: "schedule",
						name: "league-team-schedule",
						component: LeagueTeamSchedule,
						meta: {
							title: title("Team Schedule"),
						},
					},
					{
						path: "alternate-schedules",
						name: "league-team-alternate-schedules",
						component: LeagueTeamAlternateSchedules,
						meta: {
							title: title("Team Alternate Schedules"),
						},
					},
				],
			},
			{
				path: "playoffs",
				name: "league-playoffs",
				component: LeaguePlayoffs,
				meta: {
					title: title("Playoffs"),
				},
			},
			{
				path: "draft",
				component: LeagueDraftBase,
				children: [
					{
						path: "",
						name: "league-draft-dashboard",
						component: LeagueDraftDashboard,
						meta: {
							title: title("Draft Home"),
						},
					},
					{
						path: "rounds",
						name: "league-draft-rounds",
						component: LeagueDraftRounds,
						meta: {
							title: title("Draft Rounds"),
						},
					},
					{
						path: "teams",
						name: "league-draft-teams",
						component: LeagueDraftTeams,
						meta: {
							title: title("Draft Teams"),
						},
					},
				],
			},
			{
				path: "players",
				name: "league-players",
				component: LeaguePlayers,
				meta: {
					title: title("Players"),
				},
			},
			{
				path: "faqs",
				name: "league-faqs",
				component: LeagueFAQs,
				meta: {
					title: title("FAQs"),
				},
			},
		],
	},
]
